/* eslint-disable no-mixed-operators */
/* eslint-disable array-callback-return */
import { Link, Shimmer, Text } from "@fluentui/react";
import React from "react";
import classes from "./Accordion.module.scss";
import { DocumentFields, DocumentItem } from "../../services";

interface IAccordionProps {
  title: string;
  count: number;
  details: DocumentItem[];
}

interface IState {
  isActive: boolean,
  isDisable: boolean,
  isLoading: boolean
}

export default class Accordion extends React.Component<IAccordionProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isActive: false,
      isDisable: true,
      isLoading: false,
    };
  }

  renderFields(fields: DocumentFields) {
    return Object.entries(fields).map(([key, attr]) => (
      <div key={key} style={{ marginBottom: '1rem' }}>
        <strong>{attr.label}</strong>
        <ul>
          {attr.hits.map((hit, index) => (
            <li key={index} dangerouslySetInnerHTML={{ __html: hit || "<em>(no content)</em>" }} />
          ))}
        </ul>
      </div>
    ));
  }

  setIsActive(): void {
    !!this.state.isDisable &&
      this.setState({
        isActive: !this.state.isActive,
      });
  }

  render() {
    const { isActive } = this.state;
    const { title, count } = this.props;

    return (
      <div className={classes.accordion}>
        <div className={classes.accordionItem}>
          <div
            className={classes.accordionTitle}
            onClick={() => this.setIsActive()}
          >
            <div className="ms-Grid">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm11">{title}</div>
                <div
                  className={classes.textAlignRight + " ms-Grid-col ms-sm1"}
                >
                  {count}
                </div>
              </div>
            </div>
          </div>
          {isActive && (
            <div className="ms-Grid">
              <div className="ms-Grid-row">{!!this.state.isLoading && <Shimmer className={classes.shimmer} /> || this.renderContent()}</div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderContent = () => {
    const linkElements: JSX.Element[] = [];
    const documents = this.props.details || [];
    documents.length > 0 && documents[0].documentUrl !== ""
      ? documents.map((document: DocumentItem, index: number) => {
        // Remove query params
        const pathOnly = document.documentUrl.split('?')[0];
        // Get the last part of the path
        let lastSegment = pathOnly.substring(pathOnly.lastIndexOf('/') + 1);
        lastSegment = decodeURIComponent(lastSegment);
        linkElements.push(
          <div key={index} className={classes.linkItem + " ms-Grid-col ms-sm12"}>
            <strong>Link </strong>
            <Link target="_blank" href={document.documentUrl}>
              <Text> {lastSegment}</Text>
            </Link>
            {this.renderFields(document.fields)}
          </div>
        );
      })
      : linkElements.push(
        <div className={classes.linkItem + " ms-Grid-col ms-sm12"}>
          <Text>No link to show</Text>
        </div>
      );
    return linkElements;
  };
}
